// extracted by mini-css-extract-plugin
export default {"block":"cropImage_block__F6sxo","image_wrapper":"cropImage_image_wrapper__u3PL+","change_ava":"cropImage_change_ava__M0LGp","error_modal":"cropImage_error_modal__tBQ4z"};